(() => {
  'use-strict';

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      const modal = element.querySelector('.js-modal');
      const openModal = element.querySelector('.js-open-button');
      const closeModal = element.querySelector('.js-close-button');

      openModal.addEventListener('click', () => {
        modal.showModal();
      });

      closeModal.addEventListener('click', () => {
        modal.close();
      });
    });
  }

  Drupal.behaviors.mediaModal = {
    attach: () => {
      const elements = document.querySelectorAll('.js-media-modal');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
